const EnumNotificationTab = Object.freeze({
  QUESTIONS: 0,
  ANSWERS: 1,
  DISCUSSIONS: 2,
  FLAGGED_Q: 3,
  FLAGGED_A: 4,
});

export default EnumNotificationTab;
